<template>
    <el-container style="height: 100%;">
        <el-aside style="width:240px; border-right:1px solid #303133">
            <Usymbols @changeSymbol="refreshCalculation" />
        </el-aside>
        <el-container>
            <el-main v-loading="loading">
                <div class="list">
                    <List ref="ListRef" :key="componentListKey" />
                </div>
                <div class="positions">
                    <Positions :key="componentPositionsKey" />
                </div>
            </el-main>
        </el-container>
        <History ref="HistoryRef" />
        <Log ref="LogRef" />
    </el-container>
</template>
<style scoped>
.el-main {
    color: #333;
    padding: 10px 10px;
}

.list {
    height: 320px;
    max-height: 320px;
    overflow: auto;
    padding-bottom: 10px;
    margin-bottom: 20px;
}
</style>
<script setup>
import { ref, provide } from "vue";
import Usymbols from "@/components/crypto/Usymbols"
import List from '@/components/crypto/okx/entry/List.vue'
import Positions from '@/components/crypto/okx/positions/Index.vue'
import History from '@/components/crypto/okx/history/Index.vue'
import Log from '@/components/Log.vue'

const loading = ref(false)
const ListRef = ref(null)
const HistoryRef = ref(null)
const LogRef = ref(null)
const componentListKey = ref(0)
const componentPositionsKey = ref(0)

const refreshCalculation = () => {
    ListRef.value.load()
}

const reloadList = () => {
    componentListKey.value++
}

const reloadPositions = () => {
    componentPositionsKey.value++
}

const showHistory = () => {
    HistoryRef.value.showDialog()
}

const showLog = () => {
    LogRef.value.showDrawer()
}

const pannelActions = {
    reloadList: () => reloadList(),
    reloadPositions: () => reloadPositions(),
    showHistory: () => showHistory(),
    showLog: () => showLog()
}

provide("pannelActions", pannelActions)
</script>